const API_BASE = process.env.REACT_APP_API_URL || '/api';

async function request(path, options = {}) {
  const url = `${API_BASE}${path}`;
  const res = await fetch(url, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });

  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || `Request failed: ${res.status}`);
  }
  return data;
}

export function createEvent(payload) {
  return request('/events', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function getEvent(id) {
  return request(`/events/${id}`);
}

export function submitAvailability(eventId, payload) {
  return request(`/events/${eventId}/availability`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function getResults(eventId) {
  return request(`/events/${eventId}/results`);
}

export function getParticipantAvailability(eventId, participantId) {
  return request(`/events/${eventId}/availability/${participantId}`);
}

export function updateAvailability(eventId, participantId, payload) {
  return request(`/events/${eventId}/availability/${participantId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}
